var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.3554 0.224415L7.85137 3.1936C7.9226 3.30869 8.04133 3.40076 8.16006 3.42377L11.5557 3.88411C11.9119 3.93015 12.0306 4.34445 11.7931 4.57462L9.34734 6.87632C9.25236 6.96838 9.20486 7.10649 9.22861 7.24459L9.7985 10.49C9.86974 10.8352 9.48981 11.0884 9.18112 10.9273L6.16543 9.40818C6.04671 9.33913 5.90423 9.33913 5.76176 9.40818L2.74607 10.9503C2.43738 11.1114 2.0812 10.8583 2.12869 10.513L2.69858 7.26761C2.72233 7.1295 2.67484 6.9914 2.57986 6.89933L0.134064 4.59764C-0.127138 4.36747 0.0153358 3.95316 0.371519 3.90713L3.76713 3.42377C3.90961 3.40076 4.02833 3.33171 4.07582 3.1936L5.57179 0.224415C5.76176 -0.0748051 6.18918 -0.0748051 6.3554 0.224415Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.bcf167be.svg";
export { ForwardRef as ReactComponent };